// Version : 0.0.1
// Author : VISHNU
// LastEdit : SHIYAM
// Last ADD : Changed the Token as per API
// MODFIED DATE : 31-07-2025

import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/** *********************  START ADD ECONOMIC ACTIVITY TYPE  ******************** */
export const economicActivityTypeDetailsAdd = (addData: any) => {
	const data = {
		AddEconomicActivityTypeDetailsToken: addData,
	};
	const url = `${API_URL}addEconomicActivityTypeDetails`;
	return makeApiCall(url, data);
};
/** *********************  END ADD ECONOMIC ACTIVITY TYPE  ******************** */

/** *********************  START UPDATE ECONOMIC ACTIVITY TYPE  ******************** */
export const economicActivityTypeDetailsUpdate = (updateData: any) => {
	const data = {
		UpdateEconomicActivityTypeDetailsToken: updateData,
	};
	const url = `${API_URL}updateEconomicActivityTypeDetails`;
	return makeApiCall(url, data);
};
/** *********************  END ADD ECONOMIC ACTIVITY TYPE ******************** */

/** ***************** GET ECONOMIC ACTIVITY TYPE LIST START *********************** */
export const economicActivityTypeListGet = (listData: any) => {
	const data = {
		GetEconomicActivityTypeListToken: listData,
	};
	const url = `${API_URL}getEconomicActivityTypeList`;
	return makeApiCall(url, data);
};
/** ***************** GET ECONOMIC ACTIVITY TYPE LIST END *********************** */

/** ***************** FETCH ECONOMIC ACTIVITY TYPE DETAILS START *********************** */
export const economicActivityTypeDetailsFetch = (fetchData: any) => {
	const data = {
		FetchEconomicActivityTypeDetailsToken: fetchData,
	};
	const url = `${API_URL}fetchEconomicActivityTypeDetails`;
	return makeApiCall(url, data);
};
/** ***************** FETCH ECONOMIC ACTIVITY TYPE DETAILS END *********************** */

/** ***************** DELETE ECONOMIC ACTIVITY TYPE  START *********************** */
export const economicActivityTypeDetailsDelete = (deleteData: any) => {
	const data = {
		DeleteEconomicActivityTypeDetailsToken: deleteData,
	};
	const url = `${API_URL}deleteEconomicActivityTypeDetails`;
	return makeApiCall(url, data);
};
/** ***************** DELETE ECONOMIC ACTIVITY TYPE END *********************** */

/** ***************** FETCH ALL ECONOMIC ACTIVITY TYPE START *********************** */
export const allEconomicActivityTypeFetch = (fetchBranchesData: any) => {
	const data = {
		FetchAllEconomicActivityTypeListDataToken: fetchBranchesData,
	};
	const url = `${API_URL}fetchAllEconomicActivityTypeList`;
	return makeApiCall(url, data);
};
/** ***************** FETCH ALL ECONOMIC ACTIVITY TYPE END *********************** */
